import {Routes} from "@angular/router";

enum Paths {
    EMPTY = "",
    NOTIFICATIONS = "notifications",
    STATION_INFO = "station/:id"
}

const NotificationsComponent = () => import("@pages/user-settings/ui/notifications/notifications.component").then(m => m.NotificationsComponent);
const StationInfoComponent = () => import("@pages/user-settings/ui/station-info/station-info.component").then(m => m.StationInfoComponent);

export const settingsRoutes: Routes = [
    {
        path: Paths.EMPTY,
        redirectTo: "notifications",
        pathMatch: "full"
    },
    {
        path: Paths.NOTIFICATIONS,
        loadComponent: NotificationsComponent
    },
    {
        path: Paths.STATION_INFO,
        loadComponent: StationInfoComponent
    }
];
